var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRelationArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 40.3334C32.1252 40.3334 40.3334 32.1252 40.3334 22C40.3334 11.8748 32.1252 3.66669 22 3.66669C11.8748 3.66669 3.66669 11.8748 3.66669 22C3.66669 32.1252 11.8748 40.3334 22 40.3334Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2841 22.4583H29.7841",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5341 14.2083L29.7841 22.4583L21.5341 30.7083",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelationArrowCircle);
export default __webpack_public_path__ + "static/media/icon-relation-arrow-circle.d956612cd19b06c0133b15f9a3539ac1.svg";
export { ForwardRef as ReactComponent };